import { ConstantsService } from "@services/constantsService";
import { StateParams, StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-web-notification";
import { INavigationItem, SideNavigationService } from "src/app/main/navigation/sideNavigation.service";
import "./siteNavigation.scss";

class ComponentController implements angular.IComponentController {
    onNavItemClicked: () => void; 
    navigationItems: INavigationItem[] = [];

    showTooltips = false;

    isMobile: boolean;
    static $inject = ["$element", "constantsService", "sideNavigationService", "$state", "$stateParams"];

    constructor(
        private readonly $element: JQuery,
        private readonly constantsService: ConstantsService,
        private readonly sideNavigationService: SideNavigationService,
        private readonly $state: StateService, 
        private readonly $stateParams: StateParams) {

        this.init();
    }

    navItemClicked($event: MouseEvent, navItem: INavigationItem): void {
        this.sideNavigationService.removeNavItemNewStatus(navItem);

        if (this.onNavItemClicked) {
            this.onNavItemClicked();
        }
     }

     getSref(navItem: INavigationItem): string {
        if (navItem.idParam) {
          return `${navItem.uiSref}({id: '${navItem.idParam}'})`;
        }
        return navItem.uiSref;
      }
    
      isStateActive(stateName: string, params?: { [key: string]: any }): boolean {
        if (!this.$state.is(stateName)) {
          return false;
        }
    
        if (params) {
          for (const key in params) {
            if (params.hasOwnProperty(key) && this.$stateParams[key] !== params[key]) {
              return false;
            }
          }
        }
    
        return true;
      }

    // ---

    private init() {
        this.isMobile = this.constantsService.getIsMobile();
        this.showTooltips = this.$element[0].offsetWidth <= 54 && !this.isMobile;
    }
}

export class SiteNavigationComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            navigationItems: "<",
            showTooltips: "<",
            onNavItemClicked: "&"
        };

        this.controller = ComponentController;
        this.template = require("./siteNavigation.html");
    }
}
